;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  PasswordChangeRequest,
  PhoneVerifyRequest,
  ValidateTokenRequest,
} from '@qogita/canary-client'
import { CanaryClient } from '@qogita/deprecated-canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useState } from 'react'
import { SELLERS_CANARY_APPLICATION } from 'src/core/canary-application'
import { getPrivateQueryKey } from 'src/deprecated/utils/queryKey'
import {
  trackUserEmailVerified,
  trackUserPhoneVerified,
} from 'src/deprecated/utils/report/tracking'

export function getUserQueries(canaryClient: CanaryClient) {
  const queries = {
    all: () => [...getPrivateQueryKey(), 'user'] as const,
    detail: () =>
      queryOptions({
        queryKey: queries.all(),
        queryFn: () => {
          return canaryClient.getUser()
        },
      }),
    bankInfo: () =>
      queryOptions({
        queryKey: [...queries.all(), 'bankInfo'],
        queryFn: () => canaryClient.getUserBankInfo(),
      }),
  }

  return queries
}

export function useResendTokenEmailMutation() {
  const canaryClient = useCanaryClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ValidateTokenRequest) =>
      canaryClient.resendTokenEmail(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries()
    },
  })
}

export function useUpdateUserPasswordMutation() {
  const queryClient = useQueryClient()
  const [canaryClient] = useState(
    new CanaryClient({
      prefixUrl: '/api/',
      xQogitaApplication: SELLERS_CANARY_APPLICATION,
    }),
  )

  return useMutation({
    mutationFn: (data: PasswordChangeRequest) =>
      canaryClient.updateUserPassword(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries()
    },
  })
}

export function useRequestVerifyUserEmailMutation() {
  const canaryClient = useCanaryClient()
  return useMutation({
    mutationFn: () => canaryClient.requestVerifyUserEmail(),
    onSuccess: () => {
      trackUserEmailVerified()
    },
    // We don't need to invalidate anything after this mutation - it doesn't change any data
  })
}

export function useRequestVerifyUserPhoneMutation() {
  const canaryClient = useCanaryClient()
  return useMutation({
    mutationFn: (data: PhoneVerifyRequest) =>
      canaryClient.requestVerifyUserPhone(data),
    // We don't need to invalidate anything after this mutation - it doesn't change any data
    onSuccess: () => {
      trackUserPhoneVerified()
    },
  })
}
